import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-freetext-dialog',
  templateUrl: './freetext-dialog.component.html',
  styleUrls: ['./freetext-dialog.component.scss'],
  standalone: false,
})
export class FreetextDialogComponent {
  private data = inject(MAT_DIALOG_DATA);

  trademarkName!: string;
  freeText!: string;
  constructor() {
    this.trademarkName = this.data.trademarkName;
    this.freeText = this.data.freeText;
  }
}
